import { useEffect, useState, useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom'
import { IFilters } from 'types/configurations'
import { ROUTES_NAMES } from 'constants/name.routes'
import { removeFinalSpaces } from 'helper/regex'
import { InputLabel } from 'components/InputLabel'
import { InputSearch } from 'components/InputSearch'
import { InputSelect } from 'components/InputSelect'
import ActionStatus from 'components/ActionStatus'

import {
    cancelButton,
    locatedErrorSyle,
    Ptitle,
    saveButton,
    SpanTop
} from 'pages/Configurations/FormUser/styles'
import { SectorsFilters } from 'pages/Configurations/Sectors/styles'
import {
    CleanFilters,
    FilterButton,
    LineUser,
    Subtitle,
    Title
} from 'pages/Configurations/Users/styles'
import {
    EditSectorContainer,
    P,
    InputContainer,
    ActionsButtons,
    ButtonAction
} from 'pages/Configurations/EditSector/styles'
import { Dispatch } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { SectorAction, SectorReducer, Sector } from 'types/sector'
import {
    LocationAction,
    LocationReducer,
    LocationSectorList,
    LocationSector,
    LocationSectorTypeInitiator
} from 'types/location'

import SectorActions from 'actions/Sector'
import SectionService from 'services/Sector'
import { titleTableSectorsPerUnit } from 'components/SharedTable/models'
import LocationActions from 'actions/Location'
import StatusButtons from 'components/StatusButtons'
import { Message, MessageTypeInitiator } from 'types/global'
import { UserServiceNowList } from 'types/user'
import Table from 'components/Table'

const EditSector = () => {
    const navigate = useNavigate()
    const sectorDispatch: Dispatch<SectorAction> =
    useDispatch<Dispatch<SectorAction>>()
    const sectorSelector: SectorReducer = useSelector(
        (state: RootReducerState) => state.sectorReducers
    )

    const { state: currentSelectedSector } = useLocation()
    const { register, control, handleSubmit, setValue, getValues, watch } =
        useForm()
    const [selectedFilters, setSelectedFilters] = useState<IFilters>({
        search: undefined
    })


    const [sectorExists, setSectorExists] = useState(false)
    const [actionStatus, setActionStatus] = useState(false)

    const locationDispatch: Dispatch<LocationAction> =
        useDispatch<Dispatch<LocationAction>>()
    const locationSelector: LocationReducer = useSelector(
        (state: RootReducerState) => state.locationReducers
    )
    const { id } = useParams()

    const [paginationTotal, setPaginationTotal] = useState<number>(0)
    const [paginationItensByPage, setPaginationItensByPage] =
        useState<number>(10)
    const [message, setMessage] = useState<Message>(MessageTypeInitiator)
    let setMessageSuccess = (text: string) =>
        setMessage({ visible: true, status: 1, text: text } as Message)
    let setMessageError = (text: string) =>
        setMessage({ visible: true, status: 0, text: text } as Message)

    const [dataTable, setDataTable] = useState<[any, any, any, any][]>([
        [false, null, null, null]
    ])

    const [locationTableCurrentPage, setLocationTableCurrentPage] = useState<number>(0)

    const [locationOrder, setLocationOrder] = useState<any>({field: 'x_rdsls_notificabe_locations', order: 'ORDERBY'})

    let unity = watch('unity')

    const handleNavigateToSectors = () => {
        navigate(ROUTES_NAMES.configurationsRoutes.configurationsSectors)
    }
    /**
     * Evento disparado ao mudar a ordenação ou a unidade
     */
    useEffect(() => {
        if(unity && unity.trim() != ''){
            setLocationTableCurrentPage(0)
            getLocationsBySectorId(0)
        }
    }, [unity])

    /**
     * Evento usado para carregar os setores de acordo com a unidade selecionada
     */
    const onChangeLocation = useCallback((value) => {
        if(value === '')
            LocationActions.getLocationsBySectorIdV2(locationDispatch, id)
        
        setValue('unity', value)
        setPaginationTotal(1) 
    }, [])

    const handleCleanFilters = () => { 
        LocationActions.getLocationsBySectorIdV2(locationDispatch, id)
        setValue('unity', '')
        setPaginationTotal(
            parseInt(sectorSelector.sector.u_count_active) +
            parseInt(sectorSelector.sector.u_count_inactive)
        )
    }

    const handleFilterTable = (data: any) => { }

    const handleSaveEdit = (data: any) => {
        const sector: Sector = { u_name: removeFinalSpaces(data?.sectorName) }

        SectionService.updateSectorBySysId(sector, id)
            .catch(console.error)
            .then((response: any) => {
                setMessageSuccess('Setor atualizado com sucesso!')
                setValue('sectorName', '')
                setTimeout(() => {
                    navigate('/configuracoes/setores')
                    setActionStatus(false)
                }, 1000)
            })
    }

    const handleCancelEdit = () => {
        navigate(ROUTES_NAMES.configurationsRoutes.configurationsSectors)
    }
    /**
     * Busca um objeto LocationSector na store por locationId
     * @param locationId
     */
    const getLocationSector = (locationId: string): LocationSector => {
        const locations = locationSelector.locationSectorList?.filter(
            (locationSector: LocationSector) =>
                locationSector.x_rdsls_notificabe_locations.value ===
                locationId &&
                locationSector.x_rdsls_notificabe_sectors.value === id
        )
        let locationSector: LocationSector = locations[0] ? JSON.parse(JSON.stringify(locations[0])
        ) as LocationSector : LocationSectorTypeInitiator
        return locationSector
    }
    /**
     * Componente de que renderiza os ultimos botões Ativo/Inativo na tabela
     * @param status 
     * @param locationId 
     */
    const getComponentActiveInactive = (status: string, locationId: string) => {
        let locationSector: LocationSector = getLocationSector(locationId)
        
        return (
            <StatusButtons loading={locationSector.isLoading}
                currentChangeStatus={status === 'true' ? 1 : 2}
                handleChangeActiveStatus={() => {
                    locationSector.u_active.value = 'true'
                    locationSector.u_active.display_value = 'Verdadeiro'
                    locationSector.isLoading = true
                    LocationActions.updateLocationStatusCache(
                        locationDispatch,
                        locationSector
                    )
                }}
                handleChangeInactiveStatus={() => {
                    locationSector.u_active.value = 'false'
                    locationSector.u_active.display_value = 'Falso'
                    locationSector.isLoading = true
                    LocationActions.updateLocationStatusCache(
                        locationDispatch,
                        locationSector
                    )
                }}
            />
        )
    }
    /**
     * Formata as informações do Reducer para any do componente de tabela
     * @param sectorList
     */
    const getDataTable = (
        locationSectorListDataTable: LocationSectorList
    ): [any, any, any, any][] => {
        return locationSectorListDataTable
            ? locationSectorListDataTable?.map(
                (
                    locationSector: LocationSector, index:number
                ): [any, any, any, any] => {
                    return [
                        { locactionId: locationSector.x_rdsls_notificabe_locations.value },
                        locationSector.x_rdsls_notificabe_locations.display_value,
                        getLinksManagers(locationSector.location_managers),
                        getComponentActiveInactive(
                            locationSector.u_active.value,
                            locationSector.x_rdsls_notificabe_locations.value
                        )
                    ]}
            )
            : []
    }
    /**
     * Esse é o metodo usado para mudar a paginação,
     * aqui o offset é chamado via callback quando algum botão na paginação é clicado
     * Esse offset é enviado para o ServiceNow via webservice junto com o numero de itens por pagina
     * O Action pega o retorno desse webservice e
     * grava no Redux usando a propriedade 'locationSectorList' do LocationReducer
     * @param offset - Numero de retorno ao clicar em um item de paginação
     */
    const handlerPaginationTableLocationSector = (offset: number) => {
        setLocationTableCurrentPage(offset)
        getLocationsBySectorId(offset)
    }

    /**
     * Usado para renderizar a coluna de gestores
     * @param listUser 
     */
    const getLinksManagers = (listUser: UserServiceNowList) => {
        let content = [];
        if (listUser && listUser.length === 0) 
            content.push(<span className='italic text-xs text-mediumGray'>Não há gestores cadastrados nesta Unidade.</span>)
        
        if(listUser && listUser.length > 0)
            for (let i = 0; i < listUser.length; i++)
                content.push(<>
                <Link className='text-blueTheme font-medium underline' 
                    to={`/configuracoes/edicao-usuario/${listUser[i].u_user.value}`}>
                    {listUser[i].u_user.display_value}
                </Link><br/>
                </>)

        return content
    }
    /**
     * Inicia a busca pelo setor e suas unidades cadastradas
     */
    useEffect(() => {
        LocationActions.getAllLocations(locationDispatch)
        SectorActions.getSectorById(sectorDispatch, id)
        LocationActions.getLocationsBySectorIdV2(locationDispatch, id)
    }, [])
    /**
     * Quando o setor é preenchido é carregado as informações e contagem total
     */
    useEffect(() => {
        setValue('sectorName', sectorSelector.sector.u_name)
        setPaginationTotal(
            parseInt(sectorSelector.sector.u_count_active) +
            parseInt(sectorSelector.sector.u_count_inactive)
        )
    }, [sectorSelector.sector])
    /**
     * Quando a lista de unidades é preenchida é chamada a função para tabular os dados
     * e gravar no state 'dataTable'
     */
    useEffect(() => {
        let data = getDataTable(locationSelector.locationSectorList)
        setDataTable(data)
    }, [locationSelector.locationSectorList])


    useEffect(() => {
        setMessage(sectorSelector.message)
        setTimeout(()=>{setMessage(MessageTypeInitiator)}, 3000)
    }, [sectorSelector.message])

    /**
     * Usado para capturar o valor de ordenação escolhido na Table
     * @param orderFieldSelected  - Valor retornado do componete Table ao clicar na ordenação
     */
    const handlerTableOrderByField = (orderFieldSelected: any) => {
        setLocationOrder(orderFieldSelected)
        setLocationTableCurrentPage(0)
        getLocationsBySectorId(0)
    }

    const getLocationsBySectorId = (offset:number = 0) => LocationActions.getLocationsBySectorIdV2(
        locationDispatch,
        id,
        `${offset}`,
        `${paginationItensByPage}`,
        locationOrder,
        unity
    )

    return (
        <EditSectorContainer className="relative">
            <SpanTop className="mb-8">
                <span
                    className="cursor-pointer"
                    onClick={handleNavigateToSectors}
                >
                    Setores
                </span>
                <span className="text-sm">{'>'}</span>
                <span className="font-semibold">Acessar setor</span>
            </SpanTop>
            <Ptitle>{currentSelectedSector?.sectorName}</Ptitle>

            <P>
                <span>Ativo em {currentSelectedSector?.active}</span> /
                <span> Inativo em {currentSelectedSector?.inactive}</span>
            </P>

            <InputContainer onSubmit={handleSubmit(handleSaveEdit)}>
                <InputLabel
                    container="lg:w-1/2 w-full"
                    defaultValue={currentSelectedSector?.sectorName}
                    inputWidth="max-w-[737px] 2xl:w-[737px]"
                    label="Nome"
                    name="sectorName"
                    register={register}
                    className={sectorExists ? locatedErrorSyle : ''}
                    onBlur={() => setSectorExists(false)}
                    maxLength={50}
                    error={{
                        message: sectorExists
                            ? 'Desculpe, setor já cadastrado. Por favor, verifique e tente novamente.'
                            : ''
                    }}
                />

                {currentSelectedSector?.sectorName?.trim() !==
                    watch('sectorName')?.trim() && (
                        <ActionsButtons>
                            <ButtonAction
                                onClick={handleCancelEdit}
                                className={cancelButton}
                            >
                                Cancelar
                            </ButtonAction>
                            <ButtonAction type="submit" className={saveButton}>
                                Salvar
                            </ButtonAction>
                        </ActionsButtons>
                    )}
            </InputContainer>

            {message.visible && (
                <ActionStatus text={message.text} status={message.status} />
            )}

            <LineUser className="mb-6" />

            <Title>Lista de setores por Unidade</Title>

            <Subtitle>
                Confira abaixo a lista de todos as Unidades que possuem o setor,
                quem são seus gestores e qual o status do setor na Unidade.
            </Subtitle>

            <SectorsFilters onSubmit={handleSubmit(handleFilterTable)}>
                <div className="flex gap-2">
                    <div>
                    <InputSelect
                        searchPlaceHolder="Buscar"
                        onChange={onChangeLocation}
                        defaultValue={''}
                        styleContainer="w-[360px]"
                        styleBoxOptions="w-[360px] top-[55px]"
                        label="Unidade"
                        name="unity"
                        control={control}
                        onBlur={() => { 

                        }}
                        data={locationSelector.locationsList
                            ?.map((l) => ({
                                value: l.sys_id,
                                label: l.name
                            }))
                            .sort((o1, o2) =>
                                o1.label.localeCompare(o2.label)
                            )}
                        placeholder="Selecionar"
                    />
                        {unity && (
                            <CleanFilters onClick={handleCleanFilters}>
                                Limpar Filtros
                            </CleanFilters>
                        )}
                    </div>
                     {/**    
                    <FilterButton className="mt-[16.5px]">Filtrar</FilterButton>
                    */}
                </div>
                {/**
                <div className="mt-[16.5px] lg:w-1/2 w-full">
                    <InputSearch
                        handleCleanInputSearch={handleCleanInputSearch}
                        searchValue={
                            watch('searchManager')?.toLowerCase() || undefined
                        }
                        onBlur={handleFilterWithSearchOnBlur}
                        name="searchManager"
                        data-testid="searchManager"
                        register={register}
                        className="w-full"
                        placeholder="Buscar gestor"
                    />
                </div>
                 */}
            </SectorsFilters>
            <Table
                titleTable={titleTableSectorsPerUnit}
                selectedFilters={selectedFilters as IFilters}
                tableData={dataTable}
                paginationTotal={paginationTotal}
                paginationItensByPage={paginationItensByPage}
                paginationNumberSelectedPage={
                    handlerPaginationTableLocationSector
                }
                orderCollumnSelected={
                    handlerTableOrderByField
                }
                paginationCurrentPage={locationTableCurrentPage}
            />
        </EditSectorContainer>
    )
}

export { EditSector }
